export default "__VITE_ASSET__DmixKz4A__"